<template>
  <!-- 司机招募配置-统计页面招募人员列表 -->
  <el-dialog
    :visible.sync="show"
    :close-on-click-modal="false"
    :before-close="closeDialog"
    append-to-body
    width="85%"
  >
    <div class="handle-box-search">
      <div class="handle-box" style="display: flex">
        <div style="width: 70%">
          <el-row class="head-search">
            <el-col :span="12">
              <span class="title">日期:</span>
              <el-date-picker
                v-model="search_data.insert_time_stamp"
                type="month"
                placeholder="选择日期"
                format="yyyy-MM"
                value-format="yyyy-MM"
                style="width: 200px"
              >
              </el-date-picker>
            </el-col>
            <el-col :span="12">
              <span class="title">手机号:</span>
              <!-- 搜索司机手机号 -->
              <el-input
                v-model="search_data.phone"
                placeholder="请输入司机手机号"
                class="handle-input mr10"
                @keyup.enter.native="searchDriverRecruitList"
              ></el-input>
            </el-col>
          </el-row>
        </div>
      </div>

      <el-button
        type="primary"
        icon="el-icon-search"
        @click="searchDriverRecruitList"
        >搜索</el-button
      >
    </div>

    <el-table
      :data="tableData"
      style="width: 100%"
      ref="multipleTable"
      header-cell-class-name="table-header"
    >
      <el-table-column prop="recruit_driver_name" label="姓名" min-width="140">
      </el-table-column>

      <el-table-column prop="recruit_phone" label="手机号" min-width="100">
      </el-table-column>

      <el-table-column prop="time_stamp" label="招募时间" min-width="100">
      </el-table-column>

      <el-table-column prop="is_sign" label="签约状态" min-width="90">
      </el-table-column>
      <el-table-column prop="sign_time_stamp" label="签约时间" min-width="90">
      </el-table-column>
    </el-table>

    <!-- 分页组件 -->
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="search_data.page"
        :page-sizes="[10, 20, 30, 40, 50]"
        :page-size="search_data.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="result_data.count"
      >
      </el-pagination>
    </div>
  </el-dialog>
</template>

<script>
let _this;

export default {
  props: {
    isShow: Boolean,
    data: {},
  },
  watch: {
    isShow(newData, oldData) {
      _this.show = true;

      _this.search_data.driver_code = _this.data.driver_code;

      console.log("司机招募配置统计页面招募人员列表");

      _this.searchDriverRecruitList();
    },
  },
  created() {
    _this = this;
  },
  data() {
    return {
      show: false,

      search_data: {
        page: 1,
        limit: 10,

        insert_time_stamp: "",
        phone: "",
        driver_code: "",

      },

      tableData: [],
      result_data: {},
    };
  },
  methods: {
    // 关闭方法
    closeDialog() {
      _this.show = false;
      _this.search_data = {
        page: 1,
        limit: 10,

        insert_time_stamp: "",
        phone: "",
        driver_code: "",

      };
    },

    //下拉条（每页显示多少数据）变化
    handleSizeChange(val) {
      _this.search_data.limit = val;

      //初始化列表
      _this.pages_function();
    },
    //页码变化
    handleCurrentChange(val) {
      _this.search_data.page = val;
      //初始化列表
      _this.pages_function();
    },
    //翻页组件的回调
    pages_function() {
      //初始化列表
      _this.driverRecruitList();
    },

    searchDriverRecruitList() {
      _this.search_data.page = 1;
      _this.driverRecruitList();
    },
    driverRecruitList() {
      _this
        .$post("recruit/driverRecruitList", _this.search_data)
        .then((res) => {
          _this.result_data = res;
          _this.tableData = res.data;
          _this.total = res.data.total;
        });
    },
  },
};
</script>

<style scoped>
.table {
  width: 100%;
  font-size: 14px;
}

.mr10 {
  margin-right: 10px;
}

.table-td-thumb {
  display: block;
  margin: auto;
  width: 40px;
  height: 40px;
}

.el-table__row {
  height: 100px;
}
.handle-box {
  margin-bottom: 20px;
}

.handle-select {
  width: 120px;
}

.handle-input {
  max-width: 150px;
  display: inline-block;
}
</style>
